<template>
  <div class="flex-container">
    <RssFeedItem
      @get_rsslist="getRssList"
      v-for="item in artists"
      :key="item.artist_id"
      :artist="item"
      :rssList="rssList"
    ></RssFeedItem>
  </div>
</template>
<script>
import RssFeedItem from "./rss-feed-item.vue";
export default {
  components: {
    RssFeedItem
  },
  props: ["artists", "rssList"],
  methods: {
    getRssList(artist_id) {
      this.$emit("get_rsslist", artist_id);
    }
  }
};
</script>
<style scoped>
.flex-container {
  display: flex;
  flex-direction: column;
}
.row-item {
  height: 32px;
  padding: 5px 10px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}
</style>
